import { Skeleton } from '@distribusion/owl-frontend-ui'
import React, { ReactElement } from 'react'

import Money from '@components/Money'
import { useTranslation } from '@lib/i18n'
import { useParams } from '@stores/params'

import '@pages/Checkout/BookingDetails/Price/index.scss'

interface PriceProps {
  price: Money | null
  isLoading?: boolean
  installment?: Installment.Item | null
}

const Price = ({ price, isLoading = false, installment }: PriceProps): ReactElement => {
  const { t } = useTranslation()
  const [{ currency }] = useParams()

  if (!isLoading && !price) return <div className="price mb-5" data-tag="price-section" />

  return (
    <div className="price mb-3" data-tag="price-section">
      <>
        {installment && (
          <div className="row space-between price__installments gap-1">
            <div className="cell basis-auto shrink">{t('checkout.bookingDetails.installmentPayments')}</div>
            <div className="cell basis-auto no-grow">
              {installment.term}
              {' x '}
              <b>
                <Money {...installment.monthly} />
              </b>
            </div>
          </div>
        )}
        <div className="row space-between price__total" data-tag="price-total">
          <div className="cell basis-auto no-grow">{t('checkout.bookingDetails.total')}</div>
          <div className="cell basis-auto no-grow">
            <Skeleton.Text placeholder={<Money fractional={13800} currency={currency} />} loading={isLoading}>
              {price && <Money {...price} />}
            </Skeleton.Text>
          </div>
        </div>
        <div className="row price__fees-disclaimer">
          <div className="cell basis-auto shrink">{t('checkout.bookingDetails.includingFees')}</div>
        </div>
      </>
    </div>
  )
}

export default Price
